export default __webpack_public_path__ + "static/media/itas-mutua.icon.a2949478.svg";